/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ClientSDK } from "../lib/sdks.js";
import { Agents } from "./agents.js";
import { Environments } from "./environments.js";
import { Interactions } from "./interactions.js";
import { Triggers } from "./triggers.js";
import { Webhooks } from "./webhooks.js";

export class GoogleGenAI extends ClientSDK {
  private _interactions?: Interactions;
  get interactions(): Interactions {
    return (this._interactions ??= new Interactions(this._options));
  }

  private _webhooks?: Webhooks;
  get webhooks(): Webhooks {
    return (this._webhooks ??= new Webhooks(this._options));
  }

  private _agents?: Agents;
  get agents(): Agents {
    return (this._agents ??= new Agents(this._options));
  }

  private _triggers?: Triggers;
  get triggers(): Triggers {
    return (this._triggers ??= new Triggers(this._options));
  }

  private _environments?: Environments;
  get environments(): Environments {
    return (this._environments ??= new Environments(this._options));
  }
}
